export const addAlphaToColor = (color: string, alpha: number = 1): string => {
    const a = Math.max(0, Math.min(1, alpha));

    if (color.startsWith('#')) {
        const hex = color.slice(1);
        const [r, g, b] =
            hex.length === 3
                ? hex.split('').map((c) => parseInt(c + c, 16))
                : [hex.slice(0, 2), hex.slice(2, 4), hex.slice(4, 6)].map((c) =>
                      parseInt(c, 16),
                  );
        return `rgba(${r}, ${g}, ${b}, ${a})`;
    }

    const match = color.match(/(\d+),\s*(\d+),\s*(\d+)/);
    if (match) {
        const [, r, g, b] = match;
        return `rgba(${r}, ${g}, ${b}, ${a})`;
    }

    throw new Error('Invalid color format');
};
